export const LOW_BUTTON = 'greenLight2';
export const MEDIUM_BUTTON = 'blueLight2';
export const HIGH_BUTTON = 'purpule2';

export default theme => {
  const LOW = theme.palette.green.light;
  const LOW_TEXT = theme.palette.green.contrastLightText;
  const MEDIUM = theme.palette.blue.light;
  const MEDIUM_TEXT = theme.palette.blue.contrastLightText;
  const HIGH = theme.palette.purpule.main;
  const HIGH_TEXT = theme.palette.purpule.contrastText;

  return {
    container: {
      backgroundColor: theme.palette.grey[300],
      color: theme.palette.grey.main,
      paddingTop: theme.spacing(8),
      paddingBottom: theme.spacing(8),
    },
    titleGrid: {
      justifyContent: 'center',
    },
    title: {
      fontWeight: 400,
      maxWidth: 700,
      [theme.breakpoints.down('sm')]: {
        textAlign: 'center',
      },
    },
    legendContainer: {
      border: `${theme.palette.grey.main} 1px dashed`,
      padding: theme.spacing(2),
    },
    legendTitle: {
      textTransform: 'uppercase',
    },
    legendDesc: {
      fontWeight: 700,
    },
    legendBars: {
      paddingTop: `${theme.spacing(3.5)}px !important`,
    },
    legendBar: {
      height: 4,
      width: '80%',
      maxWidth: 70,
      marginBottom: theme.spacing(1),
    },
    legendBarLow: {
      backgroundColor: LOW,
    },
    legendBarMedium: {
      backgroundColor: MEDIUM,
    },
    legendBarHigh: {
      backgroundColor: HIGH,
    },
    titleSep: {
      width: 70,
      height: 4,
      backgroundColor: theme.palette.grey.main,
      marginBottom: theme.spacing(6),
      marginTop: theme.spacing(3),
      [theme.breakpoints.down('sm')]: {
        marginRight: 'auto',
        marginLeft: 'auto',
      },
    },
    gridTableTitle: {
      marginBottom: theme.spacing(4),
    },
    buttonPdfContainer: {
      color: HIGH,
      [theme.breakpoints.down('sm')]: {
        textAlign: 'center',
      },
    },
    activitiesTitleContainer: {
      textAlign: 'center',
      position: 'relative',
      '&:before': {
        position: 'absolute',
        content: '""',
        width: '100%',
        height: 0,
        top: '50%',
        left: 0,
        borderTop: `${theme.palette.grey.main} 1px dashed`,
        zIndex: 1,
      },
      [theme.breakpoints.down('sm')]: {
        display: 'none',
      },
    },
    activitiesTitle: {
      padding: `${theme.spacing(1)}px ${theme.spacing(2)}px`,
      position: 'relative',
      display: 'inline-block',
      zIndex: 3,
      backgroundColor: theme.palette.grey[300],
      fontWeight: 700,
      textTransform: 'uppercase',
    },
    gridTableHeader: {
      [theme.breakpoints.down('sm')]: {
        display: 'none',
      },
    },
    resourceTitleContainer: {
      textAlign: 'center',
      display: 'flex',
      justifyContent: 'center',
      flexDirection: 'column',
      height: '100%',
    },
    resourceTitle: {
      fontWeight: 700,
      textTransform: 'uppercase',
    },
    columnHeader: {
      marginLeft: 'auto',
      marginRight: 'auto',
      width: '80%',
      height: '100%',
      backgroundColor: theme.palette.grey.main,
      boxSizing: 'border-box',
      padding: theme.spacing(2),
      paddingTop: theme.spacing(3),
      color: theme.palette.common.white,
      textAlign: 'center',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      borderRadius: '50px 50px 0 0',
      textTransform: 'uppercase',
      '& small': {
        display: 'inline-block',
        fontWeight: 200,
        fontSize: '0.6rem',
        lineHeight: 1.4,
        marginTop: theme.spacing(0.5),
      },
    },
    tableHeaderResponsive: {
      display: 'none',
      position: 'relative',
      textAlign: 'center',
      [theme.breakpoints.down('sm')]: {
        display: 'block',
      },
    },
    tableHeaderResponsiveArrow: {
      verticalAlign: 'middle',
      marginLeft: theme.spacing(2),
      marginRight: theme.spacing(2),
    },
    tableHeaderResponsiveArrowLeft: {
      '& path': {
        transform: 'translateX(5px)',
      },
    },
    tableHeaderResponsivePicto: {
      display: 'inline-block',
      verticalAlign: 'middle',
    },
    tableContainer: {
      marginTop: -theme.spacing(1),
      [theme.breakpoints.down('sm')]: {
        height: 850,
        position: 'relative',
        overflow: 'hidden',
      },
    },
    rowGrid: {
      [theme.breakpoints.down('sm')]: {
        position: 'absolute',
        left: 0,
        top: 0,
        transition: 'transform 0.3s',
        transform: 'translateX(100%)',
      },
    },
    showRowGrid: {
      [theme.breakpoints.down('sm')]: {
        transform: 'translateX(0)',
      },
    },
    tableRowLabelContainer: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100%',
      boxSizing: 'content-box',
      paddingBottom: theme.spacing(1),
      paddingTop: theme.spacing(1),
    },
    tablePictoContainer: {
      width: '100%',
      textAlign: 'center',
      position: 'relative',
      '&:before': {
        content: '""',
        width: `calc(50% + ${theme.spacing(1)}px)`,
        height: 0,
        position: 'absolute',
        top: '50%',
        left: '50%',
        borderTop: `${theme.palette.grey.main} 1px dashed`,
        zIndex: 1,
      },
      [theme.breakpoints.down('sm')]: {
        display: 'none',
      },
    },
    tablePicto: {
      display: 'inline-block',
      width: 90,
      height: 90,
      position: 'relative',
      zIndex: 2,
    },
    tableRowTitle: {
      [theme.breakpoints.down('sm')]: {
        fontSize: '18px',
        fontWeight: 700,
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(3),
      },
    },
    rowSqrtContainer: {
      width: '100%',
      height: '100%',
      padding: theme.spacing(1),
      minHeight: 180,
      position: 'relative',
      display: 'flex',
      alignItems: 'stretch',
      flexWrap: 'nowrap',
      [theme.breakpoints.down('sm')]: {
        height: 240,
        padding: 0,
        marginBottom: theme.spacing(2),
      },
    },
    rowSqrt: {
      position: 'relative',
      padding: theme.spacing(2),
      width: '100%',
      height: '100%',
      flexGrow: 1,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      [theme.breakpoints.down('sm')]: {
        width: 'calc(100% - 70px)',
      },
    },
    rowHeader: {
      display: 'none',
      height: '100%',
      backgroundColor: theme.palette.grey.main,
      width: 70,
      borderTopLeftRadius: 30,
      borderBottomLeftRadius: 30,
      overflow: 'hidden',
      [theme.breakpoints.down('sm')]: {
        display: 'block',
      },
    },
    rowHeaderText: {
      color: theme.palette.common.white,
      width: 240,
      height: 70,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      textAlign: 'center',
      flexDirection: 'column',
      alignContent: 'center',
      justifyItems: 'center',
      transform: 'rotate(-90deg) translateY(-240px)',
      transformOrigin: '100% 0',
      '& small': {
        display: 'none',
      },
    },
    rowHeaderTextInner: {
      fontSize: '15px',
      fontWeight: 700,
      display: 'block',
      width: '100%',
      boxSizing: 'border-box',
      paddingLeft: theme.spacing(1),
      paddingRight: theme.spacing(1),
    },
    hexaPlus: {
      position: 'absolute',
      right: theme.spacing(1),
      bottom: theme.spacing(1.5),
      zIndex: 1,
    },
    rowSqrt_low: {
      backgroundColor: LOW,
      color: LOW_TEXT,
    },
    rowSqrt_medium: {
      backgroundColor: MEDIUM,
      color: MEDIUM_TEXT,
    },
    rowSqrt_high: {
      backgroundColor: HIGH,
      color: HIGH_TEXT,
    },
    dialogPaper: {
      padding: theme.spacing(5),
      overflow: 'hidden',
      [theme.breakpoints.down('sm')]: {
        margin: theme.spacing(1),
        padding: theme.spacing(2),
        width: `calc(100% - ${theme.spacing(2)}px)`,
      },
    },
    dialogPaper_low: {
      backgroundColor: LOW,
      color: LOW_TEXT,
    },
    dialogPaper_medium: {
      backgroundColor: MEDIUM,
      color: MEDIUM_TEXT,
    },
    dialogPaper_high: {
      backgroundColor: HIGH,
      color: HIGH_TEXT,
    },
    dialogTitle: {
      paddingRight: 0,
    },
    dialogClose: {
      [theme.breakpoints.down('sm')]: {
        position: 'absolute',
        right: -5,
        top: -10,
        width: '45px !important',
      },
    },
    dialogSep: {
      width: 70,
      height: 4,
      marginTop: theme.spacing(1),
    },
    dialogSep_low: {
      backgroundColor: LOW_TEXT,
    },
    dialogSep_medium: {
      backgroundColor: MEDIUM_TEXT,
    },
    dialogSep_high: {
      backgroundColor: HIGH_TEXT,
    },
    dialogContent: {
      paddingBottom: theme.spacing(2),
      columnCount: 2,
      columnGap: theme.spacing(4),
      [theme.breakpoints.down('sm')]: {
        columnCount: 1,
      },
    },
    dialogMoreInfo: {
      marginBottom: theme.spacing(3),
      breakInside: 'avoid',
    },
    dialogMoreInfoNum: {
      fontWeight: 300,
    },
    dialogMoreInfoTitle: {
      marginBottom: theme.spacing(1),
    },
  };
};
